import { motion } from "framer-motion";
import React, { useRef } from "react";
import Footer from "../index/Footer";
import Header from "../index/Header";

export default function NocheCountry() {
  const scrollRef = useRef();
  return (
    <div className="bg-white text-eryndra-forest w-full overflow-x-hidden">
      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-burgundy/20" />
      {/* Hero */}
      <section className=" bg-eryndra-country relative h-[70vh] flex items-center justify-center bg-cover bg-center text-center ">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="font-title text-5xl md:text-8xl text-eryndra-ivory mb-4  tracking-widest text-shadow-lg">
            NOCHe COUNTRY
          </h1>
          <p className="mt-4 text-lg md:text-xl font-semibold text-eryndra-ivory text-shadow-DEFAULT">
            17 de Octubre · 20:00 · Sevilla
          </p>
          <a
            target="_blank"
            href="https://entradium.com/es/events/noche-country-adriana-criado"
            className="mt-8 inline-block bg-pink-500 text-white px-6 py-3  rounded-xl shadow-lg hover:bg-pink-600 transition"
          >
            ENTRADAS AGOTADAS
          </a>
        </motion.div>
      </section>

      {/* Información */}
      <section className="max-w-4xl mx-auto py-16 px-6 text-center">
        <h2 className="text-3xl font-bold text-eryndra-forest mb-6">
          Sobre el evento
        </h2>
        <p className="text-2xl font-bellefair text-gray-700">
          Vive una noche única al estilo Country con música, ambiente temático y
          la presencia de una autora invitada muy especial. ¡Una experiencia de
          lectura y diversión que no querrás perderte!
        </p>
        <br />

        <div className=" items-center  font-bellefair">
          {/* Texto descriptivo */}
          <div className="space-y-4 text-xl ">
            <p>
              🎤 Charla y firma de <span className="font-semibold font-cinzel text-pink-600">Adriana Criado</span>.
            </p>
            <p>
              🍹 La entrada incluye <span className="font-semibold font-cinzel text-pink-600">2 consumiciones</span>.
            </p>
            <p>
              🎶 Disfruta de la <span className="font-semibold font-cinzel text-pink-600">mejor música country</span>.
            </p>
            <p>
              🤠 Actividades para pasarlo genial con toda la comunidad lectora.
            </p>
            <p>
              🕗 <span className="font-semibold font-cinzel">Duración:</span> 2 horas
              <br />
              ⏰ <span className="font-semibold font-cinzel">Hora:</span> 20:00 h
              <br />
              📅 <span className="font-semibold font-cinzel">Fecha:</span> 17 de octubre de 2025
              <br />
              📍 <span className="font-semibold font-cinzel">Lugar:</span> Urbano Comix, Sevilla
            </p>
          </div>
        </div>
      </section>

      {/* Autora invitada */}
      <section className="bg-eryndra-cream py-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-pink-600 mb-4">
          Con Adriana Criado
        </h2>
        <p className="text-gray-700 font-bold">
          Una de las mejores escritoras de novela romántica en España, conocida por
          sus historias cautivadoras y personajes inolvidables.

        </p>
        <p className="text-2xl mt-4 font-bellefair italic">¡Trae tu ejemplar! Podras hacerle todas las preguntas que quieras y llevarte tu libro firmado.</p>
        <img
          src="/img/espiritusalvaje.jpg"
          alt="Portada Espíritu Salvaje"
          className="max-w-sm rounded-xl shadow-lg mx-auto"
        />
      </section>

      {/* Cartel + Mapa */}
      <section className="max-w-3xl mx-auto py-16 px-6 grid md:grid-cols-2 gap-8 items-center">
        {/* Cartel */}
        <div>
          <img
            src="/img/nocheCountry.png"
            alt="Cartel Noche Country"
            className="rounded-xl shadow-lg mx-auto"
          />
        </div>

        {/* Mapa */}
        <div className="rounded-xl overflow-hidden shadow-lg border border-pink-200 h-full">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3156.3322761702473!2d-5.987478284695974!3d37.38530257982755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd126be6e218737f%3A0xee1e32095557e6e1!2sC.%20Matahacas%2C%205%2C%2041003%20Sevilla%2C%20España!5e0!3m2!1ses!2ses!4v1696245000000!5m2!1ses!2ses" width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" ></iframe>
        </div>
      </section>

      {/* CTA final */}
      <section
        id="entradas"
        className="text-center py-16 bg-pink-50 border-t border-pink-200"
      >
        <h2 className="text-3xl font-bold text-eryndra-forest mb-6">
          ¿Quieres venir?
        </h2>
        <a
          target="_blank"
          href="https://entradium.com/es/events/noche-country-adriana-criado"
          className="bg-pink-500 text-white px-8 py-4 rounded-xl shadow-lg hover:bg-pink-600 transition"
        >
          ENTRADAS AGOTADAS
        </a>
      </section>
      <Footer />
    </div>
  );
}
